import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import VueElementLoading from 'vue-element-loading'
import JsonExcel from 'vue-json-excel'
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'

Vue.use(VueSweetalert2)

Vue.component('downloadExcel', JsonExcel)
Vue.config.productionTip = false
Vue.component('VueElementLoading', VueElementLoading)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  beforeMount () {
    // localStorage.clear()
  },
  beforeUnmount () {
    localStorage.clear()
    // window.removeEventListener("load", this.onLoad);
    // window.removeEventListener("beforeunload", this.onUnload);
  },
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js